// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/styles' // Vuetify stil dosyaları
import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components' // Tüm bileşenleri import etmek yerine
// import * as directives from 'vuetify/directives' // Ağaç sallama (tree shaking) için ayarlar yapılabilir

const myCustomLightTheme = {
  dark: false,
  colors: {
    primary: '#1976D2', // Clean Blue
    secondary: '#EEEEEE', // Light Gray
    accent: '#009688', // Teal
    error: '#F44336', // Red
    info: '#00BCD4', // Light Blue
    success: '#43A047', // Green
    warning: '#FF6F00', // Orange
  },
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // components, // Yukarıdaki gibi import edildiğinde
  // directives,
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
})
